export default "<script src=\"../js/oidc-client.js\"></script>\n<script src=\"/js/signin-callback.js\"></script>\n";